<template>
    <uiPage :blok="blok" :airport="blok.entity" />
</template>

<script setup lang="ts">
const { blok } = defineProps<{
    blok: any;
}>();
provide('airport', blok.entity);
</script>
